export interface AABB {
  x: number;
  y: number;
  w: number;
  h: number;
}

export function aabbOverlap(a: AABB, b: AABB): boolean {
  return (
    a.x < b.x + b.w &&
    a.x + a.w > b.x &&
    a.y < b.y + b.h &&
    a.y + a.h > b.y
  );
}

export interface SweepResult {
  hitX: AABB | null;
  hitY: AABB | null;
}

/**
 * Move `box` by (dx, dy) against `solids`, resolving each axis separately so
 * sliding along walls feels right. Mutates `box` in place.
 */
export function moveAndCollide(
  box: AABB,
  dx: number,
  dy: number,
  solids: readonly AABB[],
): SweepResult {
  let hitX: AABB | null = null;
  let hitY: AABB | null = null;

  box.x += dx;
  for (const s of solids) {
    if (!aabbOverlap(box, s)) continue;
    if (dx > 0) box.x = s.x - box.w;
    else if (dx < 0) box.x = s.x + s.w;
    hitX = s;
  }

  box.y += dy;
  for (const s of solids) {
    if (!aabbOverlap(box, s)) continue;
    if (dy > 0) box.y = s.y - box.h;
    else if (dy < 0) box.y = s.y + s.h;
    hitY = s;
  }

  return { hitX, hitY };
}
